import React from "react";

import "./loaderbtn.css";
const LoaderBtn = () => {
  return (
    <div className="container-loader-btn">
      <span className="loader"></span>
    </div>
  );
};

export default LoaderBtn;
